import React from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import {
  Container,
  ContentWrapper,
  TextContent,
  Heading,
  SubHeading,
  ImageWrapper,
  Image,
  WhiteGradient
} from "./styles";
import { resolvePath } from "@utils/resolvePath";

export interface IDashcamAckoApp extends CommonProps {
  heading?: string;
  subHeading?: string;
  image?: string;
  imageStyles?: object;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const DashcamAckoApp = (props: IDashcamAckoApp) => {
  const { 
    heading, 
    subHeading,
    image,
    is_visible,
    imageStyles
  } = props;

  return is_visible ? (
    <Container>
      <ContentWrapper>
        <TextContent>
          <Heading>{heading}</Heading>
          <SubHeading>{subHeading}</SubHeading>
        </TextContent>
        {image && (
            <ImageWrapper>
              <Image src={resolvePath(image)} alt={heading} style={imageStyles} />
              <WhiteGradient/>
            </ImageWrapper>
        )}
      </ContentWrapper>
    </Container>
  ) : <></>;
};

export default connect(mapStateToProps)(DashcamAckoApp);
